import {
  GET_OUTPUT_FIELDS_REQUEST,
  GET_OUTPUT_FIELDS_SUCCESS,
  GET_OUTPUT_FIELDS_ERROR,
  GET_PROVIDER_OUTPUT_FIELDS_REQUEST,
  GET_PROVIDER_OUTPUT_FIELDS_SUCCESS,
  GET_PROVIDER_OUTPUT_FIELDS_ERROR
} from "../actions/output_fields";

import { appendOrReplaceEntity } from "@utils/reducers";

const defaultState = {
  isFetching: false,
  fetchedAt: null,
  error: null,
  data: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_OUTPUT_FIELDS_REQUEST:
    case GET_PROVIDER_OUTPUT_FIELDS_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case GET_OUTPUT_FIELDS_SUCCESS: {
      const { data } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data
      };
    }

    case GET_PROVIDER_OUTPUT_FIELDS_SUCCESS: {
      const { output_fields, table_provider_id } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: appendOrReplaceEntity(
          state.data,
          {
            output_fields,
            table_provider_id
          },
          "table_provider_id"
        )
      };
    }

    case GET_OUTPUT_FIELDS_ERROR:
    case GET_PROVIDER_OUTPUT_FIELDS_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    default: return state;
  }
};
